import React from "react";
import MapView from "../components/MapView";

export default function MapPage() {
  return <MapView />;
}
